import React, { useState, useEffect } from 'react';
import { Grid, TextField, InputAdornment, Autocomplete, InputBase, Paper } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import AccountCircle from '@mui/icons-material/AccountCircle';
import DescriptionIcon from '@mui/icons-material/Description';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AddHomeIcon from '@mui/icons-material/AddHome';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import NumbersIcon from '@mui/icons-material/Numbers';
import EmailIcon from '@mui/icons-material/Email';
import { getStorage } from '../utils/functions/localstorage';
import api from '../utils/functions/api';
import TableConfigList from '../components/DetailMerchant/TableConfigList';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { validateTaxId } from '../utils/functions/validateTaxId';
import '../custom.css';
import { swalConfirmAddText, swalErrorBtn, swalErrorTimer, swalSuccessTimer } from '../helpers/swalHelper';
import ConfigListApi from '../service/config.api';
import SearchIcon from '@mui/icons-material/Search';
import BusinessIcon from '@mui/icons-material/Business';

const textFieldStyles = {
  '& fieldset': {
    borderRadius: 30,
  },
};

function ConfigListMerchant() {
  const [userList, setUserList] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState({ direction: '', column: null });
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const [etaxStatus, setEtaxStatus] = useState(false);

  const [taxType, setTaxType] = useState('NIDN');
  const [branchID, setBranchID] = useState('');
  const [branchName, setBranchName] = useState('');
  const [customerCode, setCustomerCode] = useState('');
  const [address, setAddress] = useState([]);
  const [addressDetail, setAddressDetail] = useState('');

  const [provinces, setProvinces] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState(null);

  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);

  const [subdistricts, setSubdistricts] = useState([]);
  const [selectedSubdistrict, setSelectedSubdistrict] = useState(null);

  const [postalCode, setPostalCode] = useState('');

  const [isLinearLoading, setIsLinearLoading] = useState(false);

  const [search, setSearch] = useState('');

  const decoded = jwtDecode(getStorage('token'));
  const isJV = decoded.IS_JV; 
  
  const schema = yup.object().shape({
    // tax_id: yup
    //   .string()
    //   .required('กรุณากรอกตัวเลขประจำตัว 13 หลัก')
    //   .matches(/^[0-9]{13}$/, 'กรุณากรอกเลข 13 หลักเท่านั้น')
    //   .test('check-unique-tax-id', 'เลขบัตรไม่ถูกต้อง', async (value) => {
    //     return validateTaxId(value);
    //   }),
    name: yup
      .string()
      .required('กรุณากรอกชื่อ')
      .matches(/^[^\s]/, 'ตัวแรกต้องไม่ใช่เว้นวรรค')
      .matches(
        /^[ก-๙a-zA-Z0-9\s]+$/,
        'กรอกได้เฉพาะตัวอักษรภาษาไทย ภาษาอังกฤษ และตัวเลขเท่านั้น',
      ),
    phone_number: yup
      .string()
      .required('กรุณากรอกตัวเลข 10 หลัก')
      .matches(/^[0-9]{10}$/, 'กรุณากรอกเบอร์โทร 10 หลักเท่านั้น'),
    one_mail: yup
      .string()
      .required('กรุณากรอก email')
      .test(
        'is-valid-email-list',
        'กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง (สามารถกรอกหลายอีเมลได้โดยใช้จุลภาคคั่น)',
        (value) => {
          if (!value) return true;
          const emails = value.split(',').map((email) => email.trim());
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emails.every((email) => emailRegex.test(email));
        },
      ),
    addressDetail:
      etaxStatus &&
      yup
        .string()
        .required('กรุณากรอกที่อยู่')
        .matches(
          /^[^\u{1F600}-\u{1F64F}\u{2702}-\u{27B0}\u{1F680}-\u{1F6FF}\u{1F1E6}-\u{1F1FF}]*$/u,
          'กรุณากรอกที่อยู่ให้ถูกต้อง',
        ),
    selectedProvince:
      etaxStatus &&
      yup
        .object()
        .shape({
          id: yup.number().required(),
          name_th: yup.string().required(),
        })
        .required('กรุณาเลือกจังหวัด'),

    selectedDistrict:
      etaxStatus &&
      yup
        .object()
        .shape({
          id: yup.number().required(),
          name_th: yup.string().required(),
        })
        .required('กรุณาเลือกอำเภอ'),
    selectedSubdistrict:
      etaxStatus &&
      yup
        .object()
        .shape({
          id: yup.number().required(),
          name_th: yup.string().required(),
        })
        .required('กรุณาเลือกตำบล'),
  });
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = async (data) => {
    await handleCreate(data);
  };

  const handleDialogCreate = () => {
    setOpenDialogCreate(true);
  };
  const handleClearFields = () => {
    setAddress('');
    setTaxType('NIDN');
    setBranchID('');
    setBranchName('');
    setSelectedProvince(null);
    setSelectedDistrict(null);
    setSelectedSubdistrict(null);
    setPostalCode('');
    setCustomerCode('');

    reset({
      tax_id: '',
      name: '',
      phone_number: '',
      one_mail: '',
      addressDetail: '',
    });
  };
  const handleCloseDialogCreate = () => {
    handleClearFields();
    setOpenDialogCreate(false);
  };

  const handleChange = (e) => {
    const selectedTaxType = e.target.value;
    setTaxType(selectedTaxType);

    // เคลียร์ branchID เมื่อเปลี่ยนประเภทผู้เสียภาษีอากรเป็นบุคคลธรรมดาหรืออื่นๆ
    if (selectedTaxType !== 'TXID') {
      setBranchID('');
    }
  };
  const handleBranchIDChange = (e) => {
    const inputBranchID = e.target.value;
    const filteredBranchID = inputBranchID.replace(/[^a-zA-Z0-9]/g, '');
    if (filteredBranchID.length <= 5) {
      setBranchID(filteredBranchID);
    }
  };
  const handleBackspaceBranchID = (e) => {
    if (e.key === 'Backspace' && branchID && branchID.length > 0) {
      setBranchID(branchID.slice(0, -1));
    }
  };

  const getProvince = async () => {
    try {
      const resp = await ConfigListApi.getProvincesApi();
      setProvinces(resp?.data);
    } catch (e) {
      throw new Error(e);
    }
  };

  useEffect(() => {
    getProvince();
  }, []);

  const handleProvinceChange = (value) => {
    if (value) {
      getDistricts(value.id);
      setSelectedProvince(value);
    }
  };

  const getDistricts = async (provinceID) => {
    try {
      const resp = await ConfigListApi.getDistrictApi(provinceID);
      setDistricts(resp?.data);
      return resp.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const handleDistrictChange = (value) => {
    if (value) {
      getSubdistricts(value.id);
      setSelectedDistrict(value);
    }
  };

  const getSubdistricts = async (districtID) => {
    try {
      const resp = await ConfigListApi.getSubDistrictApi(districtID);
      setSubdistricts(resp?.data);
      return resp.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const handleSubdistrictChange = (value) => {
    if (value) {
      setSelectedSubdistrict(value);
      setPostalCode(value.zip_code);
      setValue('postalCode', value.zip_code);
    }
  };

  const getConfigList = async () => {
    const sortBy = sort.column
      ? `${sort.column}:${sort.direction}`
      : 'createdAt:desc';

      try {
        setIsLinearLoading(true);
        const resp = await ConfigListApi.getCustomerApi(search, page, rowsPerPage, sortBy);
        setUserList(resp?.data[0].data);
        setTotal(resp?.data[0].metadata[0] ? resp?.data[0].metadata[0].total : 0);
        setEtaxStatus(resp?.etaxStatus);
      } catch (e) {
        throw new Error(e);
      } finally {
        setIsLinearLoading(false);
      }
  };

  const handleCreate = async (item) => {
    const fixedItem = {
      ...item,
      name: item.name.trim(),
      one_mail: item.one_mail.trim(),
    };

    if (taxType === 'TXID' && branchID.length !== 5) {
      return;
    }

    if (isJV) {
      if (branchName === '') {
        return;
      }
    }

    if (customerCode === '' && fixedItem.tax_id === '') {
        swalErrorBtn({title: `กรุณากรอก Customer Code หรือ Tax ID`})
        return;
    }

    const fixAddress = {
      address_detail: item.addressDetail || '',
      province: {
        name: selectedProvince?.name_th || '',
        id: selectedProvince?.id || null,
      },
      district: {
        name: selectedDistrict?.name_th || '',
        id: selectedDistrict?.id || null,
      },
      sub_district: {
        name: selectedSubdistrict?.name_th || '',
        id: selectedSubdistrict?.id || null,
      },
      zip_code: selectedSubdistrict?.zip_code || '',
    };

    const isAddressValid =
      fixAddress.address_detail &&
      fixAddress.province.id &&
      fixAddress.district.id &&
      fixAddress.sub_district.id &&
      fixAddress.zip_code;

     // ถ้าไม่กรอกที่อยู่ครบ ให้แสดง Dialog ยืนยัน
  if (!isAddressValid) {
    // ปิด Dialog เพิ่มลูกหนี้ก่อน
    setOpenDialogCreate(false); // ปิด Dialog

    const confirmResult = await swalConfirmAddText({
      title: 'ยืนยันการดำเนินการ',
      text: 'หากกรอกข้อมูลที่อยู่ไม่ครบถ้วน ระบบจะไม่บันทึกที่อยู่',
      icon: 'warning'
    });

    if (!confirmResult.isConfirmed) {
      setOpenDialogCreate(true); // เปิด Dialog เพิ่มลูกหนี้อีกครั้งถ้าผู้ใช้เลือกยกเลิก
      return;
    }
  }


    try {
      const response = await ConfigListApi.createDebtorApi(taxType, fixedItem, branchID, branchName, isAddressValid, fixAddress, customerCode);
      swalSuccessTimer({title: 'เพิ่มลูกหนี้สำเร็จ', timer: 3000});
      handleClearFields();
      await getConfigList();
      setOpenDialogCreate(false);
      return response;
    } catch (error) {
      swalErrorTimer({title: 'ไม่สามารถเพิ่มลูกหนี้ได้', text: error.message, timer: 3000});
    }
  };

  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      getConfigList();
    }
  };

  const handleSearchConfig = () => {
    getConfigList();
  };

  useEffect(() => {
    getConfigList();
    return () => {};
  }, [rowsPerPage, page, sort]);
  return (
    <div>
      <div className="my-2 ml-2">
        <div className="text-lg font-light flex items-center ">
          <div className="py-6 text-xl">แก้ไขลูกหนี้ </div>
        </div>
          <div>
            <Grid container spacing={1}>
              <Grid item xs={4} md={4} lg={4}>
                <Paper
                  component="form"
                  sx={{
                    pl: 2,
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '20px',
                    justifyContent: 'space-between',
                    boxShadow: 'none',
                    border: '1px solid #CCCCCC',
                  }}
                >
                  <InputBase
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    onKeyDown={handleKeyEnter}
                    fullWidth
                    placeholder="ค้นหา"
                  />
                  <div className="p-[8px]">
                    <SearchIcon
                      sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                    />
                  </div>
                </Paper>
              </Grid>
              <Grid item xs={3} md={2} lg={1}>
                <div>
                  <Button
                    variant="contained"
                    sx={{
                      background: 'primary',
                      color: 'white',
                      borderRadius: '20px',
                    }}
                    onClick={() => handleSearchConfig()}
                  >
                    ค้นหา
                  </Button>
                </div>
              </Grid>
              <Grid item xs={4} md={4} lg={4}>
                <Button
                  variant="contained"
                  sx={{
                    background: 'primary',
                    color: 'white',
                    borderRadius: '20px'
                  }}
                  onClick={() => {
                    handleDialogCreate();
                  }}
                >
                  เพิ่มลูกหนี้
                </Button>
              </Grid>
            </Grid>
        </div>
      </div>
      <Dialog
        open={openDialogCreate}
        onClose={handleCloseDialogCreate}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { minWidth: 'auto', maxWidth: 'auto' } }}
      >
          <DialogTitle id="alert-dialog-title">
            <div className="flex">
              <div>{'เพิ่มลูกหนี้'}</div>
              <div className="ml-2">
                <GroupAddIcon />
              </div>
            </div>
          </DialogTitle>
          <DialogContent sx={{ paddingBottom: '12px' }}>
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={2} sx={{ textAlign: 'start' }}>
                <Grid
                  item
                  xs={12}
                  // md={!isJV ? 8 : 12}
                  md={8}
                  sx={{ marginTop: '5px', marginTop: '2%' }}
                >
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="tax-id-label">
                      ประเภทผู้เสียภาษีอากร*
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="tax-id-label"
                      id="tax-id-select"
                      value={taxType}
                      label="ประเภทผู้เสียภาษีอากร"
                      onChange={handleChange}
                      startAdornment={
                        <InputAdornment position="start">
                          <PeopleOutlineIcon />
                        </InputAdornment>
                      }
                    >
                      <MenuItem value="TXID">
                        เลขประจำตัวผู้เสียภาษีอากรสำหรับนิติบุคคล
                      </MenuItem>
                      <MenuItem value="NIDN">
                        เลขประจำตัวประชาชน (สำหรับบุคคลธรรมดา)
                      </MenuItem>
                      <MenuItem value="CCPT">
                        เลขหนังสือเดินทาง (Passport)
                      </MenuItem>
                      <MenuItem value="OTHR">อื่นๆ</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={12}
                  // md={!isJV ? 4 : 6}
                  md={4}
                  sx={{ marginTop: '5px', marginTop: '2%' }}
                >
                  <TextField
                    fullWidth
                    value={taxType === 'TXID' ? branchID : ''}
                    id="outlined-basic"
                    label="เลขที่สาขา"
                    placeholder=""
                    disabled={taxType !== 'TXID'}
                    variant="outlined"
                    onChange={handleBranchIDChange}
                    onKeyDown={handleBackspaceBranchID}
                    error={taxType === 'TXID' && branchID.length !== 5}
                    helperText={
                      taxType === 'TXID' && branchID.length !== 5
                        ? 'กรุณากรอกเลขที่สาขาให้ครบ 5 หลัก'
                        : ''
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessIcon/>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                {isJV && (
                <Grid item xs={12} md={6} sx={{ marginTop: '5px', marginTop: '2%' }}>
                  <TextField
                    fullWidth
                    value={branchName}
                    id="outlined-basic"
                    label="ชื่อสาขา"
                    placeholder=""
                    variant="outlined"
                    onChange={(e) => setBranchName(e.target.value)}
                    error={branchName === '' ? 'กรุณากรอกชื่อสาขา' : ''}
                    helperText={branchName === '' ? 'กรุณากรอกชื่อสาขา' : ''}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessIcon/>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                )}

                {isJV && (
                <Grid item xs={12} md={6} sx={{ marginTop: '5px', marginTop: '2%' }}>
                  <TextField
                    fullWidth
                    value={customerCode}
                    id="outlined-basic"
                    label="Customer Code"
                    placeholder=""
                    variant="outlined"
                    onChange={(e) => setCustomerCode(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle/>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                )}

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('tax_id')}
                    // error={!!errors.tax_id}
                    // helperText={errors.tax_id?.message}
                    id="outlined-basic"
                    label="เลขประจำตัวผู้เสียภาษี*"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DescriptionIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('name')}
                    error={!!errors.name}
                    helperText={errors.name?.message}
                    id="outlined-basic"
                    label="ชื่อ-นามสกุล*"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('phone_number')}
                    error={!!errors.phone_number}
                    helperText={errors.phone_number?.message}
                    id="outlined-basic"
                    label="หมายเลขโทรศัพท์*"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AddIcCallIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    {...register('one_mail')}
                    error={!!errors.one_mail}
                    helperText={errors.one_mail?.message}
                    id="outlined-basic"
                    label="Email*"
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    id="outlined-basic"
                    label="ที่อยู่ เลขที่ / ซอย / ถนน"
                    fullWidth
                    variant="outlined"
                    error={!!errors.addressDetail}
                    helperText={
                      errors.addressDetail ? errors.addressDetail.message : ''
                    }
                    {...register('addressDetail')}
                    onChange={(e) => setAddressDetail(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AddHomeIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    name="selectedProvince"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={provinces}
                        getOptionLabel={(option) => option.name_th}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="จังหวัด"
                            variant="outlined"
                            error={!!errors.selectedProvince}
                            helperText={errors.selectedProvince?.message}
                          />
                        )}
                        onChange={(_, data) => {
                          field.onChange(data);
                          handleProvinceChange(data);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.name_th === value?.name_th
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    name="selectedDistrict"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={districts}
                        getOptionLabel={(option) => option.name_th}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="อำเภอ"
                            variant="outlined"
                            error={!!errors.selectedDistrict}
                            helperText={errors.selectedDistrict?.message}
                          />
                        )}
                        onChange={(_, data) => {
                          field.onChange(data);
                          handleDistrictChange(data);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.name_th === value?.name_th
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Controller
                    name="selectedSubdistrict"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={subdistricts}
                        getOptionLabel={(option) => option.name_th}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="ตำบล"
                            variant="outlined"
                            error={!!errors.selectedSubdistrict}
                            helperText={errors.selectedSubdistrict?.message}
                          />
                        )}
                        onChange={(_, data) => {
                          field.onChange(data);
                          handleSubdistrictChange(data);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.name_th === value?.name_th
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="รหัสไปรษณีย์"
                    error={!!errors.postalCode}
                    helperText={
                      errors.postalCode ? errors.postalCode.message : ''
                    }
                    value={postalCode}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <div className="flex justify-between px-4 pb-1">
            <DialogActions>
              <Button onClick={handleClearFields} color="error">
                Clear
              </Button>
            </DialogActions>
            <DialogActions>
              <Button onClick={handleCloseDialogCreate} autoFocus color="error">
                ยกเลิก
              </Button>

              <Button onClick={handleSubmit(onSubmit)} variant="outlined">
                ยืนยันการเพิ่มลูกหนี้
              </Button>
            </DialogActions>
          </div>
      </Dialog>

      <TableConfigList
        userList={userList}
        rowsPerPage={rowsPerPage}
        page={page}
        total={total}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        sort={sort}
        setSort={setSort}
        setUserList={setUserList}
        getConfigList={getConfigList}
        provinces={provinces}
        districts={districts}
        subdistricts={subdistricts}
        getDistricts={getDistricts}
        getSubdistricts={getSubdistricts}
        statusETax={etaxStatus}
        isLinearLoading={isLinearLoading}
      />
    </div>
  );
}

export default ConfigListMerchant;
